import React from 'react';
export const WhyKodaGroup = () => {
  return <section className="py-20 bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 w-full" data-id="element-312">
      <div className="container mx-auto px-4" data-id="element-313">
        <div className="max-w-5xl mx-auto" data-id="element-314">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-center mb-12 text-white" data-id="element-315">
            Why Koda Group Inc.?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-white" data-id="element-316">
            <div data-id="element-317">
              <h3 className="font-bold text-2xl mb-4 text-blue-100" data-id="element-318">
                Law Enforcement Heritage
              </h3>
              <p className="text-blue-50 leading-relaxed mb-8" data-id="element-319">
                Our founder's distinguished career as a Detroit Police
                Department officer, including recognition as Officer of the
                Year, provides the foundation for our investigative excellence.
                We bring the discipline, ethics, and tactical expertise of law
                enforcement to every case.
              </p>
              <h3 className="font-bold text-2xl mb-4 text-blue-100" data-id="element-320">
                Advanced Certifications
              </h3>
              <p className="text-blue-50 leading-relaxed" data-id="element-321">
                As one of only two licensed Certified Criminal Defense
                Investigators (CCDI) in Michigan and the only licensed CCDI in
                Ohio, we offer specialized expertise that few firms can match.
                Our team also includes Certified Construction Investigators for
                job site injury cases.
              </p>
            </div>
            <div data-id="element-322">
              <h3 className="font-bold text-2xl mb-4 text-blue-100" data-id="element-323">
                Cutting-Edge Technology
              </h3>
              <p className="text-blue-50 leading-relaxed mb-8" data-id="element-324">
                From high-definition surveillance equipment to GPS tracking
                devices and electronic monitoring systems, we deploy the latest
                investigative technology to gather admissible evidence
                efficiently and effectively.
              </p>
              <h3 className="font-bold text-2xl mb-4 text-blue-100" data-id="element-325">
                Confidential & Discreet
              </h3>
              <p className="text-blue-50 leading-relaxed" data-id="element-326">
                Your case receives the utmost confidentiality and
                professionalism. We understand the sensitive nature of private
                investigations and conduct all operations with absolute
                discretion while maintaining the highest ethical standards.
              </p>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-blue-700 text-center" data-id="element-327">
            <p className="text-xl text-blue-100 mb-6 leading-relaxed" data-id="element-328">
              Whether you're an attorney building a case, a business protecting
              your interests, or an individual seeking answers, Koda Group Inc.
              delivers the evidence and insights you need to make informed
              decisions.
            </p>
            <a href="#contact" className="inline-flex items-center bg-white hover:bg-gray-100 text-kgi-blue-900 font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-329">
              Schedule a Consultation
            </a>
          </div>
        </div>
      </div>
    </section>;
};